// @flow

import React, { type Node } from 'react';
import { IfFeature } from '@tectonics/prs/feature';
import { useCurrentAllFeatures } from '@tectonics/prs/payment-spec';
import { getSafetycashImageSrc } from './images';

const BANKS = [
  'pichincha',
  'sana-sana',
  'guayaquil',
  'mi-vecino',
  'cruz-azul',
];

export function SafetypayCashForm(): Node {
  const allFeatures = useCurrentAllFeatures();
  return (
    <div style={{ gridColumn: '1/3' }}>
      <IfFeature allFeatures={allFeatures} wanted="display_safetypay_cash_banks">
        <p style={{ opacity: '0.5' }}>
          Una vez que generes tu código de pago en efectivo, tendrás 72 hrs para realizar tu pago en las siguientes opciones:
        </p>
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: '0.5em',
        }}>
          {BANKS.map((bankName) => (
            <img
              key={bankName}
              src={getSafetycashImageSrc(bankName)}
              style={{ height: '40px', maxWidth: '100%', margin: '0.25em' }}
              alt={bankName} />
          ))}
        </div>
      </IfFeature>
    </div>
  );
}
